

import { RoadRage } from '../../RoadRage';
import { GameData } from '../../server/data/BaseModel';
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { SplashController, SplashIndex } from '../../independent/splashScreen/SplashController';
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';

export class SetupSummary extends Presentation {

    protected gameData:GameData;
    
    checkForActivation(data: GameData): boolean { 
        return data.isLastSetupFS;
    }

    setGamedData(data: GameData): void {
        this.gameData = data;
    }

    preStart(): void {
        SplashController.instance.setData(SplashIndex.SUMMARY,this.gameData);
    }
    
    createPresentation(skip:Function): void {

        skip(false);
        
        if(RoadRage.counter.timeRemaining){
            this.timeline.to(this,{duration:RoadRage.counter.timeRemaining});
            return;
        }

        SlotGame.keypadPlugin.hide(1);
        this.timeline.add(SplashController.instance.play(SplashIndex.SUMMARY,false,() => {
            
        }));
        this.timeline.add(() => SplashController.instance.stop())
        this.PresentationState.setInactive();
    }

    public done(): void {
        SlotGame.keypadPlugin.show();
        RoadRage.reelManager.miniCovering(true);
        if(this.gameData.raw.nextMode !== GameMode.NORMAL)
            SlotGame.keypadPlugin.setZeroBetSpinCounter(this.gameData.raw.freespinsLeft);
    }
}